export default __webpack_public_path__ + "5fdfabea5f08a2c1dce07d5484ba133b.svg";